/*global module */
module.exports = {
	dashed: '8, 8',
	solid: ''
};



//////////////////
// WEBPACK FOOTER
// ./~/mindmup-mapjs-layout/src/line-strokes.js
// module id = 126
// module chunks = 0